import { render, staticRenderFns } from "./identityExamine.vue?vue&type=template&id=343d5050&scoped=true&"
import script from "./identityExamine.vue?vue&type=script&lang=js&"
export * from "./identityExamine.vue?vue&type=script&lang=js&"
import style0 from "./identityExamine.vue?vue&type=style&index=0&id=343d5050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343d5050",
  null
  
)

export default component.exports